const axios = require('axios');
const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const UserService = {
    register: async (data) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api/register`, data, { withCredentials: true });
            return response;
        } catch(err) {
            return err.response;
        }
    },
    login: async (data) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api/login`, data, { withCredentials: true });
            return response;
        } catch(err) {
            return err.response;
        }
    },
    logout: async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/api/logout`, { withCredentials: true });
            return response;
        } catch(err) {
            return err.response;
        }
    },
    info: async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/api/user`, { withCredentials: true });
            return response;
        } catch(err) {
            return err.response;
        }
    }
}

export default UserService;